import SwipeableViews from 'react-swipeable-views';
import { useState } from 'react';

import { Divider, Tab, TabPanel, Tabs } from 'evee-ui-common/components/base';
import { customer } from 'evee-ui-common/types';

import Reviews from 'widgets/profile/Reviews';

const ProfileReviews = ({ reviews }) => {
  const [value, setValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <>
      <Tabs indicatorColor="primary" value={value} centered={false} onChange={handleTabChange}>
        <Tab
          disabled={!reviews.asOwner.length}
          label={`From renters (${reviews.asOwner.length})`}
        />
        <Tab
          disabled={!reviews.asRenter.length}
          label={`From owners (${reviews.asRenter.length})`}
        />
      </Tabs>

      <Divider />

      <SwipeableViews index={value} onChangeIndex={handleChangeIndex}>
        <TabPanel value={value} index={0} padding="0 16px">
          <Reviews reviews={reviews.asOwner} />
        </TabPanel>

        <TabPanel value={value} index={1} padding="0 16px">
          <Reviews reviews={reviews.asRenter} />
        </TabPanel>
      </SwipeableViews>
    </>
  );
};

ProfileReviews.propTypes = {
  reviews: customer.reviewsPropType,
};

ProfileReviews.defaultProps = {
  reviews: {
    asOwner: [],
    asRenter: [],
  },
};

export default ProfileReviews;
